<template>
  <div class="floor-switcher gm-panel gm-panel--flush">
    <button class="floor-btn" title="Go to the floor above" @click="floorUp">
      <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 10l4-4 4 4"/></svg>
    </button>
    <div class="floor-display">
      <span class="floor-eyebrow">Floor</span>
      <span class="floor-value">{{ currentFloor }}</span>
    </div>
    <button class="floor-btn" title="Go to the floor below" @click="floorDown">
      <svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6l4 4 4-4"/></svg>
    </button>
  </div>
</template>

<script>
export default {
  name: 'WorldEditorFloorSwitcher',
  props: {
    currentFloor: {
      type: Number,
      required: true
    }
  },
  emits: ['floor-up', 'floor-down'],
  methods: {
    floorUp() {
      this.$emit('floor-up');
    },
    floorDown() {
      this.$emit('floor-down');
    }
  }
}
</script>

<style scoped>
.floor-switcher {
  flex: none;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 56px;
  background: rgba(24, 27, 28, 0.94);
  backdrop-filter: blur(6px);
  box-shadow: var(--gm-shadow);
}

.floor-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 26px;
  background: none;
  border: none;
  color: var(--gm-text-muted);
  cursor: pointer;
  transition: color var(--gm-duration) var(--gm-ease), background var(--gm-duration) var(--gm-ease);
}

.floor-btn:hover {
  color: var(--gm-accent);
  background: var(--gm-accent-softer);
}

.floor-btn:focus-visible {
  outline: 1px solid var(--gm-border-hi);
  outline-offset: -1px;
}

.floor-btn svg {
  width: 14px;
  height: 14px;
  fill: none;
  stroke: currentColor;
  stroke-width: 1.6;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.floor-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.05rem;
  padding: 0.25rem 0;
  border-top: 1px solid var(--gm-border-dim);
  border-bottom: 1px solid var(--gm-border-dim);
}

.floor-eyebrow {
  font-family: var(--gm-font-display);
  font-size: var(--gm-text-micro);
  font-weight: 500;
  letter-spacing: var(--gm-track-eyebrow);
  text-transform: uppercase;
  color: var(--gm-text-dim);
}

.floor-value {
  font-family: var(--gm-font-display);
  font-size: 1.05rem;
  font-weight: 700;
  line-height: 1;
  color: var(--gm-accent);
  font-variant-numeric: tabular-nums;
}
</style>
